import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');


const RenderTrusteddevices = () => {


const resturl=sessionStorage.getItem("REST_URL");

const navigate = useNavigate();
const location = useLocation();

window.addEventListener("keypress", function (event) {
 // detect event key
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});





const [tbltrustdevices, setTbltrustdevices] = useState([]);

const [trust, setTrust] = useState({value:"", aduser:""});




useEffect(() => {
	document.title =   "Worksheet";	
	if (sessionStorage.getItem("AW_USERNAME")==null){
	navigate("../logout");
	return;
	}
	gettbltrustdevices();

},[]);



async function gettbltrustdevices(){

const adusername=sessionStorage.getItem("AD_USERNAME");
const trustvalue=localStorage.getItem(adusername+"@customsapps.gov.tc")?localStorage.getItem(adusername+"@customsapps.gov.tc"):"";
setTrust({value:trustvalue, aduser:adusername});
const params={
	awusername: sessionStorage.getItem("AW_USERNAME")
	, adusername: adusername
	, trust: trustvalue
	};

console.log("params: "+JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };


  await fetch(resturl+'rarlogin/gettbltrustdevices',requestOptions)
      .then(res => res.json())
      .then(res => aftergettbltrustdevices(res))
      .catch(err => { console.log(err); });
	  
return false;
}//end function

function aftergettbltrustdevices(res){

let htmrows=[];

res.map((col, index) => {
	const key='device_'+index;
	//const celllink='sadlinkid'+index;
	const i=index;
	
	htmrows.push(<tr key={key} >
		<td align="right" >{index+1}</td>
		<td align="left"  >{col['DEVICE']}</td>
		<td align="center"  >{col['CURRENT_DEVICE']}</td>
		<td align="center"  >{col['FIRST_TRUST']}</td>
		<td align="left"  >{col['FIRST_IP']}</td>
		</tr>
		);//end push
		
	});//end map

	setTbltrustdevices(htmrows);
	
	
}//end func


{/*
LOGIN_NAME
DEVICE
FIRST_TRUST
LAST_TRUST
FIRST_IP
LAST_IP
*/}





  return (
    <>
<div align="center" style={{marginTop:"36px", fontWeight:"bold"}} >Trusted Devices for user {trust.aduser} </div>
 <table className="customers" style={{width:"55%", marginTop:"12px", marginBottom:"36px" }}  >
 <thead>
 <tr>
 <th>#</th>
 <th>Device Name</th>
 <th>Current Device</th>
 <th>First Trusted</th>
 <th>First Ip</th>
 </tr>
 </thead>
 <tbody>
 {tbltrustdevices}
 </tbody>
 </table>
 <div align="center" style={{marginTop:"18px", fontWeight:"bold"}} >local storage trust {trust.value} </div>




    </>
  );
};

export default RenderTrusteddevices;